<template>
  <neu-cards-slider class="section py-lg-5 py-0" :cards="cards" :title="$t('openlegal.advantages')" :iconsColor="ORANGE_COLOUR"></neu-cards-slider>
</template>

<script>
// import NeuCardsFourElements from '@/components/base/ui/NeuCardsFourElements'
import NeuCardsSlider from '@/components/base/ui/NeuCardsSlider'
import { ORANGE_COLOUR } from '@/constants/colours'

export default {
  components: {
    // NeuCardsFourElements,
    NeuCardsSlider
  },
   data () {
    return {
      cards: [
        {
          title: this.$t('openlegal.cards.first.title'),
          subtitle: this.$t('openlegal.cards.first.description'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/clock.svg'
        },
        {
          title: this.$t('openlegal.cards.second.title'),
          subtitle: this.$t('openlegal.cards.second.description'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/lock.svg'
        },
        {
          title: this.$t('openlegal.cards.third.title'),
          subtitle: this.$t('openlegal.cards.third.description'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/star.svg'
        },
        {
          title: this.$t('openlegal.cards.fourth.title'),
          subtitle: this.$t('openlegal.cards.fourth.description'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/tick.svg'
        }
      ],
      ORANGE_COLOUR
    }
  }
}
</script>

<style lang="scss" scoped>
.section {
  @include desktop{
  padding-left: 5rem !important;
  padding-right: 5rem !important;
  }
  @include desktop-sm{
  padding-left: 5rem !important;
  padding-right: 5rem !important;
  }
  @include tablets{
  padding-left: 5rem !important;
  padding-right: 5rem !important;
  }
}
.neu-cards-slider2 {
    @include media(mobile, tablets) {
      .row {
        display: block;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;

        [class*="col-"] {
          display: inline-block;
          width: 100%;
        }
      }
    }


    .card-ctn2 {
      display: block;

      @include desktop {
        padding: 0 2rem;
      }
      @include desktop-sm {
        padding: 0 2rem;
      }
      @include tablets {
        padding: 0;
      }
      @include media(tablets, mobile) {
        margin-right: 5rem;
        padding-right: 4rem;
        padding-left: 4rem;
        padding-top: 4rem;
        padding-bottom: 2rem;
      }

      .neu-card {
        display: block;
            transition-duration: 9999999s;
            justify-content:center ;
        &:hover {
            @include desktop {
                padding: 5rem;
            }
            @include desktop-sm {
              padding: 0rem 5rem;
            }
      
      transition-duration: 999999999s;
      }
        @include desktop {
          padding: 5rem;
          height: 400px;
          width: 320px;
        }
        @include desktop-sm {
          padding: 0rem 5rem;
          height: 400px;
          width: 320px;
        }

        @include tablets {
          padding: 7rem;
          width: 100%;
          max-width: none;

          span {
            margin: auto;
          }
        }

        @include mobile {
          padding: 5rem 3rem;
          margin-bottom: 3rem;
          min-height: 280px;
        }
      }
      
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/views/openlegal/OpenlegalCardsSlider.vue